<template>
  <div class="flex flex-col mt-16 font-sans-serif bg-white h-auto w-full">
    <div>
      <div class="border-b-2 border-orange-academy-150 pb-2 text-lg flex justify-between
      font-medium items-center">
        <h1 class="text-lg">{{$t('skills.personal-information')}}</h1>
        <button class="w-auto text-orange-academy-300 mr-3 transform hover:scale-105"
          @click="saveData" v-if="showSaveButton" >
            <save-icon class="w-6"></save-icon>
        </button>
      </div>
      <div class="flex mt-10 w-full justify-between items-center">
        <material-input :name="$t('skills.firstname')" class="w-full pr-4"
        v-model="editedStudent.firstname" @input="showSaveButton = true" />
        <material-input class="w-full" v-model="editedStudent.lastname"
        @input="showSaveButton = true" :name="$t('skills.lastname')" />
      </div>
      <div class="flex mt-10 w-full justify-between items-center">
        <material-input :name="$t('skills.address')"  v-model="editedStudent.address"
        @input="showSaveButton = true" class="w-full" />
      </div>
      <div class="flex mt-10 w-full justify-between items-center">
        <material-input class="w-full pr-4" v-model="editedStudent.city"
        @input="showSaveButton = true" :name="$t('skills.city')"/>
        <material-input class="w-full" v-model="editedStudent.postcode"
        @input="showSaveButton = true" :name="$t('skills.postcode')" />
      </div>
      <div class="flex mt-10 w-full justify-between items-center">
        <material-input class="w-full pr-4" v-model="editedStudent.state"
        @input="showSaveButton = true" :name="$t('skills.state')"/>
        <material-input  class="w-full" v-model="editedStudent.country"
        @input="showSaveButton = true" :name="$t('skills.country')" />
      </div>
      <div class="flex mt-10 w-full justify-between items-end">
        <material-input :name="$t('skills.phone')" class="w-full pr-4"
          v-model="editedStudent.phone" @input="showSaveButton = true" />
        <material-input :name="$t('skills.age')" class="w-full" v-model="editedStudent.age"
        @input="showSaveButton = true" />
      </div>
      <div class="flex mt-10 w-full justify-between items-end">
        <material-input :name="$t('skills.educationalTitle')" class="w-full"
          v-model="editedStudent.qualification" @input="showSaveButton = true" />
      </div>
    </div>
    <div class="flex flex-col mt-16">
      <div class="border-b-2 border-orange-academy-150 pb-2 text-lg flex justify-start
      font-medium">
        {{$t('skills.studies')}}
      </div>
      <div class="flex flex-col items-start mt-6 w-full">
        <school-row
          v-for="school in schools"
          :key="school.id"
          :school="school"
          @updated="somethingHasBeenUpdated" />
        <add-new-school v-model="addSchool" @school-added="somethingHasBeenUpdated" />
      </div>
    </div>
    <div class="flex flex-col mt-16">
      <div class="border-b-2 border-orange-academy-150 pb-2 text-lg flex justify-start
        font-medium">
          {{ $t('skills.instruments') }}
      </div>
      <div class="flex flex-col items-start mt-6 w-full">
        <instrument-row
          v-for="instrument in instruments"
          :key="instrument.id"
          :instrument="instrument"
          @updated="somethingHasBeenUpdated" />
        <add-new-instrument v-model="addInstrument" @instrument-added="somethingHasBeenUpdated" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AlgoliaMixin from '@/mixins/AlgoliaMixin';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import { updateStudentData, getStudentSchools, getStudentInstruments } from '@/services/StudentService';
import MaterialInput from '../graphics/MaterialInput.vue';
import SchoolRow from '../SchoolRow.vue';
import InstrumentRow from '../InstrumentRow.vue';
import SaveIcon from '../graphics/SaveIcon.vue';
import AddNewSchool from '../AddNewSchool.vue';
import AddNewInstrument from '../AddNewInstrument.vue';

export default {
  components: {
    MaterialInput,
    SchoolRow,
    InstrumentRow,
    SaveIcon,
    AddNewSchool,
    AddNewInstrument,
  },

  data() {
    return {
      editedStudent: {
        firstname: '',
        lastname: '',
        address: '',
        postcode: '',
        city: '',
        state: '',
        country: '',
        age: '',
        phone: '',
        qualification: '',
      },

      schools: [],
      addSchool: false,

      instruments: [],
      addInstrument: false,

      showSaveButton: false,
    };
  },

  mounted() {
    Object.keys(this.editedStudent).forEach((key) => {
      this.editedStudent[key] = this.student[key];
    });
    if (this.editedStudent.age) {
      this.editedStudent.age = this.editedStudent.age.toString();
    }
  },

  computed: {
    ...mapGetters({
      student: 'auth/student',
      user: 'auth/user',
    }),
  },

  mixins: [AlgoliaMixin, StreamFunctionsMixin],

  created() {
    this.getSchools();
    this.getInstruments();
  },

  methods: {
    getSchools() {
      getStudentSchools(this.user.id).then(({ data }) => {
        this.schools = data;
      });
    },

    getInstruments() {
      getStudentInstruments(this.student.id).then(({ data }) => {
        this.instruments = data;
      });
    },

    saveData() {
      updateStudentData(this.student.id, this.editedStudent).then(() => {
        this.showSaveButton = false;
        this.createNotification('success', this.$t('skills.success'));
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorTryAgain'));
      });
    },

    somethingHasBeenUpdated() {
      this.getSchools();
      this.getInstruments();
      this.reset();
    },

    reset() {
      this.addSchool = false;
      this.addInstrument = false;
    },

  },
};
</script>
